import React from 'react';
import {
  Copy,
  Heading,
  Stack,
  StackSpace,
} from '@grubhubprod/gh-cookbook-react';

export type PageTitleProps = {
  title: string;
  subtitle?: string;
  y?: StackSpace;
};

export const PageTitle: React.FC<PageTitleProps> = ({
  title,
  subtitle,
  y = 'x-sm',
}) => {
  return (
    <>
      {subtitle ? (
        <>
          <Stack y={y}>
            <Heading variant="h1">{title}</Heading>
          </Stack>
          <Copy variant="body">{subtitle}</Copy>
        </>
      ) : (
        <Heading variant="h1">{title}</Heading>
      )}
    </>
  );
};
